import FlexPane from 'presentation/components/flex-pane/index.js';
import Text from 'presentation/components/text/index.js';

const OutrightScoreboard = props => {
    const {
        mojitoTools: { config, style },
        event,
    } = props;

    return (
        <FlexPane config={config.container} class="OutrightScoreboard">
            <FlexPane config={config.eventNameContainer}>
                <Text config={style.eventName}>{event.name}</Text>
            </FlexPane>
        </FlexPane>
    );
};

export default OutrightScoreboard;

OutrightScoreboard.getStyle = (config, _, merge) => {
    const { primaryColor, eventName } = config;
    return {
        eventName: merge({ style: { color: primaryColor } }, eventName),
    };
};
